import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'AnalyticalSection';
const ENDPOINT = `/analytical-sections/`;

@Injectable({
    providedIn: 'root'
})
export class AnalyticalSectionService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
